import { laravel_api } from './index'

interface TOSResponse {
    version_tag: string
    content: string
    summary: string
}

interface ReacceptanceStatusResponse {
    accepted: boolean
    content: string | null
    summary: string | null
}

export const extendedApiSlice = laravel_api.injectEndpoints({
    endpoints: (builder) => ({
        getTermsOfService: builder.query<TOSResponse, undefined>({
            query: (params) => ({
                url: `/api/v2/terms-of-service`,
                params,
                method: 'GET'
            })
        }),
        getReacceptanceStatus: builder.query<ReacceptanceStatusResponse, void>({
            query: () => ({
                url: `/api/v2/terms-of-service/reacceptance-status`,
                method: 'GET'
            }),
            providesTags: ['UserAcceptance']
        }),
        confirmReacceptance: builder.mutation<void, void>({
            query: () => ({
                url: '/api/v2/terms-of-service/confirm-reacceptance',
                method: 'POST'
            }),
            invalidatesTags: ['UserAcceptance']
        })
    })
})

export const {
    useGetTermsOfServiceQuery,
    useGetReacceptanceStatusQuery,
    useConfirmReacceptanceMutation
} = extendedApiSlice
